import styled from 'styled-components';

type Props = {
  isHidden?: boolean
}

export const Wrapper = styled.div<Props>`
    visibility: ${({ isHidden }) => (isHidden ? 'hidden' : 'visible')};
`;

export const HeaderMain = styled.div`
&&& {
    font-weight: 800;
}`;
